import { createFileRoute } from '@tanstack/react-router'

import { AuthErrorComponent } from '@/shared/auth/components/common/error-component'
import { AuthPendingComponent } from '@/shared/auth/components/common/pending-component'
import { SSOCallback } from '@/shared/auth/components/forms/sso-callback'

export const Route = createFileRoute('/_auth/sso-callback')({
	component: SSOCallbackRoute,
	pendingComponent: AuthPendingComponent,
	errorComponent: AuthErrorComponent,
})

function SSOCallbackRoute() {
	return (
		<>
			<title>SSO Sign In | BitLyft AIR®</title>

			<SSOCallback />
		</>
	)
}
